import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import { CreateArtForm } from "../components/CreateArtForm";
import { useLocation } from "react-router-dom";

const Section = styled.section`
  min-height: ${(props) => `calc(100vh - ${props.theme.navHeight})`};
  width: 100vw;
  position: relative;
  background-color: ${(props) => props.theme.body};
`;


const PageContainer = styled.div`
  width: 90%;
  max-width: 780px;
  margin: 0 auto;
  padding: 2rem 1.5rem 4rem;

  @media (max-width: 48em) {
    padding: 1.5rem 1rem 3rem;
  }
`;


/* Shown when user is not logged in */
const GuestContainer = styled.div`
  width: 80%;
  min-height: 50vh;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;

  @media (max-width: 64em) {
    width: 85%;
  }
  @media (max-width: 48em) {
    width: 90%;
    padding: 1rem;
  }
`;

const GuestTitle = styled.h2`
  font-size: ${(props) => props.theme.fontxxl};
  text-transform: capitalize;
  width: 80%;
  color: ${(props) => props.theme.text};
  align-self: flex-start;

  span {
    text-transform: uppercase;
    font-family: "Akaya Telivigala", cursive;
  }
  .text-3 {
    color: red;
  }

  @media (max-width: 70em) {
    font-size: ${(props) => props.theme.fontxl};
  }
  @media (max-width: 48em) {
    align-self: center;
    text-align: center;
  }
  @media (max-width: 40em) {
    width: 90%;
  }
`;

const GuestDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 10px 0;

  p {
    color: ${(props) => `rgba(${props.theme.textRgba}, 0.6)`};
    font-size: ${(props) => props.theme.fontlg};
    font-weight: 600;
    margin-bottom: 0;
  }
  p span {
    color: orange;
  }

  @media (max-width: 48em) {
    align-self: center;
    text-align: center;
  }
`;

const GuestActionDiv = styled.div`
  width: 45%;
  display: flex;
  flex-direction: column;
  margin-top: 50px;

  p {
    color: ${(props) => `rgba(${props.theme.textRgba}, 0.6)`};
    font-size: ${(props) => props.theme.fontlg};
    font-weight: 600;
    margin-bottom: 0;
  }

  button {
    margin: 10px 0;
    width: 100%;
    padding: 20px;
    border-radius: 20px;
    background-color: black;
    color: white;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background-color: white;
      color: black;
      border: 2px solid black;
    }
  }

  @media (max-width: 64em) {
    width: 85%;
  }
  @media (max-width: 48em) {
    width: 85%;
    align-self: center;
    text-align: center;
  }
`; 

const CreateArt = () => {
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const club = location.state?.club || null;

  useEffect(() => {
    const token = localStorage.getItem("userId");
    setIsLoggedIn(!!token);
  }, []);

  return (
    <Section id="create-art">
      <Navigation />

      {isLoggedIn ? (
        <PageContainer>
          {/* 
            CreateArtForm is self-contained and already handles:
            - Page title & subtitle
            - Club badge (if club prop is passed)
            - All form sections with labels & descriptions
            - Royalty slider
            - Media + preview image uploaders
          */}
          <CreateArtForm club={club} />
        </PageContainer>
      ) : (
        <GuestContainer>
          <GuestDiv>
            <GuestTitle>
              <span>Create Your</span> <span className="text-3">Art</span>
            </GuestTitle>
            <p>
              <Link to="/">Home</Link>
              <span> · Create</span>
            </p>
          </GuestDiv>

          <GuestActionDiv>
            <p>Please connect your wallet to view this page</p>
            <Link to="/connect-wallet">
              <button>Connect Wallet</button>
            </Link>
          </GuestActionDiv>
        </GuestContainer>
      )}

      <Footer />
    </Section>
  );
};

export default CreateArt;
